import type { DBUser, RestUpdateUserPassword } from "@KassaroAB/shared/types/user";
import type {
  RestUpdateStoreUser,
} from "@KassaroAB/shared/types/StoreUser";
import { api } from "../utils/api";
import type { StoreId, ResellerId, UserId, PermissionGroupId } from "@KassaroAB/shared/types/ids";

type StoreUser = DBUser & {
  permissionGroup?: PermissionGroupId;
}

export const getUserApi = async (): Promise<DBUser> => {
  return api.get(`users`);
};

export const getStoreUsersApi = async (storeId: StoreId): Promise<StoreUser[]> => {
  return api.get(`stores/${storeId}/users`);
};

export const addStoreUserApi = async (
  storeId: StoreId,
  userData: {
    email: string;
    password?: string;
    permissionGroup?: PermissionGroupId;
    chainAccess?: boolean;
  }
): Promise<StoreUser> => {
  return api.post(`stores/${storeId}/users`, userData);
};

export const updateStoreUserApi = async (
  storeId: StoreId,
  userId: UserId,
  data: RestUpdateStoreUser
): Promise<StoreUser> => {
  return api.post(`stores/${storeId}/users/${userId}`, data);
};

export const updateStoreUserPasswordApi = async (
  storeId: StoreId,
  userId: UserId,
  data: RestUpdateUserPassword
): Promise<void> => {
  return api.put(`stores/${storeId}/users/${userId}/password`, data);
};

export const removeStoreUserApi = async (
  storeId: StoreId,
  userId: string
): Promise<void> => {
  return api.delete(`stores/${storeId}/users/${userId}`);
};

export const getResellerUsersApi = async (resellerId: ResellerId): Promise<StoreUser[]> => {
  return api.get(`resellers/${resellerId}/users`);
};

export const addResellerUserApi = async (
  resellerId: ResellerId,
  userData: { email: string; password?: string }
): Promise<StoreUser> => {
  return api.post(`resellers/${resellerId}/users`, userData);
};

export const removeResellerUserApi = async (
  resellerId: ResellerId,
  userId: string
): Promise<void> => {
  return api.delete(`resellers/${resellerId}/users/${userId}`);
};